import styled, { keyframes } from "styled-components";
import { fadeInLeft } from "react-animations";

// Keyframes
const fadeInRightAnimation = keyframes`${fadeInLeft}`;
// Styles
export const CurrentResponsiveImg = styled.img`
  margin: auto;
  max-width: 270px;
  display: none;
  border-radius: ${({ allBorder }) => (allBorder ? "5px" : "5px 5px 0 0")};
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    display: flex;
  }
`;
export const InfoButton = styled.button`
  margin: 20px auto;
  padding: 2px 15px;
  width: 85%;
  border: none;
  display: none;
  align-items: center;
  justify-content: space-between;
  background-color: #ccc;
  cursor: pointer;
  @media (max-width: 910px) {
    display: flex;
  }
`;
export const InfoText = styled.p`
  font-size: 14px;
  color: #000;
`;
export const InfoArrowImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const IndicatorMainDiv = styled.div`
  margin: auto;
  width: 100%;
  min-height: 110px;
  display: flex;
  @media (max-width: 910px) {
    height: auto;
    display: ${({ display }) => (display ? "flex" : "none")};
    animation: 1s ${fadeInRightAnimation};
  }
`;
export const IndicatorDiv = styled.div`
  margin: auto;
  width: 100%;
  height: 100%;
  max-width: 860px;
  display: flex;
  @media (max-width: 910px) {
    padding: 0 0 10px;
    width: 85%;
    border-bottom: 2px solid #ccc;
    animation: 1s ${fadeInRightAnimation};
  }
`;
export const ProtocolVideoButton = styled.button`
  margin-right: 16px;
  width: 128px;
  height: 110px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  border: none;
  cursor: pointer;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const ProtocolVideoButtonResponsive = styled.button`
  margin: auto;
  max-width: 270px;
  display: none;
  background: transparent;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  border: none;
  cursor: pointer;
  @media (max-width: 910px) {
    display: flex;
    flex-direction: column;
  }
`;
export const ButtonAndImgDiv = styled.div`
  padding: 5px 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
`;
export const VideoButtonImg = styled.img`
  margin-right: 15px;
  width: 23px;
  height: 23px;
`;
export const VideoText = styled.p`
  color: #999;
  font-size: 14px;
`;
export const CurrentImg = styled.img`
  margin-right: 16px;
  width: 128px;
  height: 70px;
  border-radius: ${({ allBorder }) => (allBorder ? "5px" : "5px 5px 0 0")};
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    display: none;
  }
`;
export const IndicatorTextDiv = styled.div`
  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const IndicatorText = styled.p`
  font-size: 14px;
  color: #000;
`;
export const IndicatorTitle = styled.span`
  font-weight: bold;
`;
export const IndicatorDataDiv = styled.div`
  margin: 20px auto;
  padding: 10px;
  width: 100%;
  max-width: 860px;
  background-color: #ccc;
  border-radius: 5px;
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const IndicatorDataText = styled.p`
  font-size: 18px;
  color: #fff;
`;
export const SessionHeaderMainDiv = styled.div`
  margin: 0 auto 10px;
  width: 100%;
  max-width: 860px;
  @media (max-width: 910px) {
    margin: 0 auto 10px;
    width: 85%;
    max-width: 860px;
  }
`;
export const SessionHeaderDiv = styled.div`
  width: 100%;
  display: flex;
`;
export const SessionTitle = styled.p`
  padding: ${({ padding }) => padding && padding};
  width: ${({ width }) => width && width};
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  text-align: center;
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
    font-size: 12px;
  }
`;
export const SessionHideDiv = styled.div`
  display: flex;
  @media (max-width: 910px) {
    display: none;
  }
`;
